<h2>Insurance <button class="icon--history btn--default" type="button" (click)="showHistory(customerNumber)">View History</button></h2>
<p-table  #dt [value]="insurancePolicies" styleClass="p-datatable-striped">
    <ng-template pTemplate="header">
        <tr>
            <th>Company Name</th>
            <th>Policy Number</th>
            <th>Policy Type</th>
            <th>Policy Source Type</th>
            <th class="w--date">Notify Date</th>
            <th class="w--date">Effective Date</th>
            <th class="w--date">End Date</th>
        </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
        <tr>
            <td [attr.colspan]="7">
                No records found
            </td>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowData>
        <tr [pSelectableRow]="rowData">
            <td>{{rowData.companyName}}</td>
            <td>{{rowData.policyNumber}}</td>
            <td>{{rowData.policyType}}</td>
            <td>{{rowData.policySourceType}}</td>
            <td>{{rowData.notifyDate | shortDate}}</td>
            <td>{{rowData.effectiveDate | shortDate}}</td>
            <td>{{rowData.endDate| shortDate}}</td>
        </tr>
    </ng-template>
</p-table>